export enum DifferenceFormat {
  SECONDS,
  MINUTES,
  HOURS,
  MONTHS,
  YEARS,
}
